export const culturalTables = [
  {
    id: 'italian',
    name: 'Italian Table',
    description: 'Experience the flavors of Italy with pasta, pizza, and more.',
    imageUrl: 'italian-table.jpg',
    flag: '🇮🇹'
  },
  {
    id: 'japanese',
    name: 'Japanese Table',
    description: 'Discover the delicate balance of sushi, ramen, and tempura.',
    imageUrl: 'japanese-table.jpg',
    flag: '🇯🇵'
  },
  {
    id: 'indian',
    name: 'Indian Table',
    description: 'Savor the rich spices of curry, naan, and biryani.',
    imageUrl: 'indian-table.jpg',
    flag: '🇮🇳'
  },
  {
    id: 'american',
    name: 'American Table',
    description: 'Enjoy classic American comfort food like burgers, fries, and apple pie.',
    imageUrl: 'american-table.jpg',
    flag: '🇺🇸'
  },
  {
    id: 'mexican',
    name: 'Mexican Table',
    description: 'Explore vibrant flavors with tacos, guacamole, and enchiladas.',
    imageUrl: 'mexican-table.jpg',
    flag: '🇲🇽'
  },
  {
    id: 'korean',
    name: 'Korean Table',
    description: 'Taste the bold flavors of kimchi, bulgogi, and bibimbap.',
    imageUrl: 'korean-table.jpg',
    flag: '🇰🇷'
  }
];